/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2026 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { getStoreConfigResponse } from '@/auth/types';
import { COOKIE_LIFETIME } from '@/auth/configs/cookieConfigs';
import { StoreConfigModel } from '../models';

export const transformStoreConfig = (
  response: getStoreConfigResponse
): StoreConfigModel => {
  return {
    autocompleteOnStorefront:
      response?.data?.storeConfig?.autocomplete_on_storefront || false,
    // Need information about min length in response undefined
    minLength: response?.data?.storeConfig?.minimum_password_length || 3,
    requiredCharacterClasses:
      +response?.data?.storeConfig?.required_character_classes_number || 0,
    createAccountConfirmation:
      response?.data?.storeConfig?.create_account_confirmation || false,
    customerAccessTokenLifetime:
      response?.data?.storeConfig?.customer_access_token_lifetime *
        COOKIE_LIFETIME || COOKIE_LIFETIME,
    websiteName: response?.data?.storeConfig?.website_name || '',
    shoppingAssistanceEnabled:
      response?.data?.storeConfig?.shopping_assistance_enabled || false,
    shoppingAssistanceCheckboxTitle:
      response?.data?.storeConfig?.shopping_assistance_checkbox_title || '',
    shoppingAssistanceCheckboxTooltip:
      response?.data?.storeConfig?.shopping_assistance_checkbox_tooltip || '',
  };
};
